import http from '../helpers/http';
import { FilteredOptionsInterface, makeQueryParamsForRequest } from '../entities/FilteredOptions';

const PerformanceVerbalWarning = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    create: async (body: any) => {
      const result = await http.post('/verbal-warning', body, { headers });
      return result.data;
    },
    show: async (id: string) => {
      const result = await http.get(`/verbal-warning/${id}`, {
        headers,
      });
      return result.data;
    },
    listByEmployee: async (employeeId: string, filteredOptions?: FilteredOptionsInterface) => {
      const params = makeQueryParamsForRequest(filteredOptions);
      const result = await http.get(`/verbal-warning/by-employee/${employeeId}`, {
        headers,
        params,
      });
      return result.data;
    },
    listBySchool: async (schoolId: string, filteredOptions?: FilteredOptionsInterface) => {
      const params = makeQueryParamsForRequest(filteredOptions);
      const result = await http.get(`/verbal-warning/by-school/${schoolId}`, {
        headers,
        params,
      });
      return result.data;
    },
    getPriorDiscussions: async (userId: string) => {
      const result = await http.get(`/performance-management/by-user/${userId}`, {
        headers,
      });
      return result.data;
    },
    getUserVerbalWarnings: async (userId: string, type: string = 'verbal-warning') => {
      const result = await http.get(`/performance-management/by-user/${userId}`, {
        headers,
        params: { type },
      });
      return result.data;
    },
    approve: async (id: string) => {
      const result = await http.patch(`/verbal-warning/${id}/approve`, {}, { headers });
      return result.data;
    },
    reject: async (id: string) => {
      const result = await http.delete(`/verbal-warning/${id}/reject`, { headers });
      return result.data;
    },
    delete: async (id: string) => {
      const result = await http.delete(`/verbal-warning/${id}`, { headers });
      return result.data;
    },
    update: async (id: string, body: any) => {
      const result = await http.put(`/verbal-warning/${id}`, body, { headers });
      return result.data;
    },
    listPending: async (schoolId: string) => {
      const result = await http.get(`/verbal-warning/by-school/${schoolId}/pending`, { headers });
      return result.data?.data ?? result.data ?? [];
    },
    getTemplateDocument: async (id: string): Promise<Blob> => {
      const result = await http.get(`/verbal-warning/${id}/template-document`, {
        headers,
        responseType: 'blob',
      });
      return result.data;
    },
    finalize: async (id: string, formData: FormData) => {
      const result = await http.patch(`/verbal-warning/${id}/finalize`, formData, {
        headers: { 'x-access-token': token },
      });
      return result.data;
    },
  };
};

export default PerformanceVerbalWarning;
